"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TOOL_GENERATED_ARTIFACTS = void 0;
exports.isToolGeneratedArtifact = isToolGeneratedArtifact;
exports.TOOL_GENERATED_ARTIFACTS = {
    altium: [{ directory: 'history', extensions: ['.zip', '.log'] }],
    xpedition: [
        { directory: 'projectbackup', extensions: ['.zip'] },
        { directory: 'cdbback', extensions: ['.zip'] },
        { directory: 'pcb', extensions: ['.prj'] },
    ],
};
function isToolGeneratedArtifact(relativePath, tool) {
    if (tool === null) {
        return false;
    }
    const rules = exports.TOOL_GENERATED_ARTIFACTS[tool];
    if (rules === undefined) {
        return false;
    }
    const segments = relativePath.split('/');
    const fileName = segments.at(-1)?.toLowerCase() ?? '';
    const directories = segments.slice(0, -1).map((segment) => segment.toLowerCase());
    return rules.some((rule) => directories.includes(rule.directory) && rule.extensions.some((extension) => fileName.endsWith(extension)));
}
//# sourceMappingURL=tool-generated-artifacts.js.map